module.exports = __webpack_public_path__ + "img/firestone_banner_ch.83f13cbc.png";